<template>
  <div class="incubatorPage">
    <LeftTree />
    <RightContent style="width:calc(100% - 300px)"/>
  </div>
</template>

<script>

import LeftTree from './components/LeftTree.vue';
import RightContent from './components/right/RightContent.vue';



export default {
  components: {
    LeftTree,
    RightContent
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin() {
      const currentUser = this.$store.getters.userInfo.scope;
      if (currentUser.sysScope && currentUser.sysAdmin) {
        //系统管理员
        return "isSysAdmin";
      }
      else if (currentUser.sysScope && !currentUser.sysAdmin) {
        //系统非管理员
        return "isSysNoAdmin";
      }
      else if (!currentUser.sysScope && currentUser.scopeAdmin || currentUser.type === 2) {
        //非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return "noSysIsAdmin";
      }
      else {
        //非系统非管理员
        return "noSysNoAdmin";
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.incubatorPage {
  height: 100%;
  display: flex;
  position: relative;
}
</style>
